/**
 * Domec treats inputs with length >= 30 as provider serials. Account save accepts only
 * shorter web codes from the purchase confirmation email.
 */
export const GIFT_CARD_SERIAL_MIN_LENGTH = 30;
export const GIFT_CARD_WEB_CODE_MAX_LENGTH = GIFT_CARD_SERIAL_MIN_LENGTH - 1;

export type GiftCardAccountAddErrorCode = 'duplicate' | 'expired' | 'invalid' | 'generic';

/** Trim and uppercase a shopper-entered gift card web code. */
export function normalizeGiftCardWebCode(value: string): string {
    return value.trim().toUpperCase();
}

/** Whether the value looks like a Domec serial rather than a web code. */
export function isGiftCardSerialShaped(value: string): boolean {
    return value.length >= GIFT_CARD_SERIAL_MIN_LENGTH;
}
